/* eslint-disable */
import { Link, useParams } from "react-router-dom";

const HealthCenterCommonHeader = ({ moduleName }) => {
  // Retrieve route parameters using the useParams hook from react-router-dom.
  const params = useParams();

  // Define navigation links in a JSON array for better scalability and maintainability.
  const navLinks = [
    {
      to: `/admin/clinicalmanagement/healthcenters/save/${params.id}`,
      label: "General Info", //"General Info"
      module: "save",
    },
    {
      to: `/admin/clinicalmanagement/healthcenters/contracts/${params.id}`,
      label: "Contracts", //"Contracts"
      module: "contracts",
    },
    {
      to: `/admin/clinicalmanagement/healthcenters/staff/${params.id}`,
      label: "Clinic Staffs", //"Clinic Staffs"
      module: "teammembers",
    },
    {
      to: `/admin/clinicalmanagement/healthcenters/goals/${params.id}`,
      label: "Goals", //"Peoples"
      module: "goals",
    },
    {
      to: `/admin/clinicalmanagement/healthcenters/schedule/${params.id}`,
      label: "Schedule", //"Schedule"
      module: "schedule",
    },
    {
      to: `/admin/clinicalmanagement/healthcenters/articles/${params.id}`,
      label: "Articles",
      module: "articles",
    },
    {
      to: `/admin/clinicalmanagement/healthcenters/successstories/${params.id}`,
      label: "Success Stories",
      module: "successstories",
    },
  ];

  return (
    // Main container for the inner menu with a white background and a subtle shadow.
    <div className="inner-menu-container bg-white border border-gray-300 shadow-none mt-3 rounded-10">
      <div className="container-fluid px-lg-5">
        {/* Unordered list for the secondary menu, designed to be flexible and responsive. */}
        <ul className="nav secondary-menu mw-100 flex-nowrap gap-xl-5 flex-fill fs-sm fw-semibold text-center border-0 text-nowrap overflow-auto">
          {/* Map through the navLinks array to dynamically generate each navigation item. */}
          {navLinks.map((link) => (
            <li className="nav-item flex-fill" key={link.module}>
              {/* Link component from react-router-dom for client-side navigation. */}
              <Link
                to={link.to}
                className={`d-block text-black px-2 px-sm-3 py-3 py-sm-4 position-relative ${
                  moduleName === link.module && "active"
                }`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default HealthCenterCommonHeader;
